import { render, staticRenderFns } from "./ShopCreate.vue?vue&type=template&id=51679b7a&scoped=true&"
import script from "./ShopCreate.vue?vue&type=script&lang=js&"
export * from "./ShopCreate.vue?vue&type=script&lang=js&"
import style0 from "./ShopCreate.vue?vue&type=style&index=0&id=51679b7a&scoped=true&lang=css&"
import style1 from "./ShopCreate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51679b7a",
  null
  
)

export default component.exports